import { Store } from "@bryntum/schedulerpro";
import { ContextCard } from "../models/ContextCard";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { SwivuConnectedStoreMixin } from "./mixins/SwivuConnectedStoreMixin";

export class SwivuContextCardStore extends SwivuConnectedStoreMixin(Store) {
  static get $name() {
    return "SwivuContextCardStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.contextCardsStore,
      storeId: STORE_KEYS.contextCardsStore,
      modelClass: ContextCard,
    };
  }
}